import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Typography,
  Divider,
  Box,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SignaturePad from "react-signature-canvas";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { useStyles } from "./DocumentSignStyles";
//import { mainStyles, theme } from "../../styles/Main.js"
// import { ReactComponent as ClearIcon } from "../../assets/clear.svg";
import {
  CustomAlertMaterial,
  CustomLoadingOverlay,
  GenericContainer,
  Buttons,
  GeoLocationGeneric,
  AlertConfirm,
} from "../../components";
import {
  documentsActions,
  fileActions,
  workflowActions,
  addTitleLegoCurrent,
} from "../../store/actions";
import { obtenerDireccionIP, coreFunctions } from "../../utils";
import { Alert } from "../../components/Alert";
import { documentsRequests } from "../../services";
import { useTranslation } from "react-i18next";

export default function CanvasPdfSignComponent(props) {
  const matches = useMediaQuery("(min-width:650px)");
  const { useState, useRef, useEffect } = React;
  const [hidden, setHidden] = useState(false);
  const [finFirma, setFinFirma] = useState();
  const [inicioFirma, setInicioFirma] = useState();
  const [properties, setProperties] = useState([]);
  const [signBase64, setSignBase64] = useState(false);
  const [acceptButton, setAcceptButton] = useState("");
  const [latitude, setLatitude] = useState("-85.05112878");
  const [longitude, setLongitude] = useState("-180");
  const [loadView, setLoadView] = useState(false);
  const [singContinue, setSingContinue] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [cargaInicial, setCargaInicial] = useState(false);
  const [ipDirection, setIpDirection] = useState(null);
  const containerSignDetectRef = useRef(null);
  const [isWriteSign, setIsWriteSign] = useState(false);
  const [estaFirmando, setEstaFirmando] = useState(false);
  const { t } = useTranslation();
  const windowHeight = window.innerHeight;

  const navigate = useNavigate();
  const theme = useTheme();
  const location = useLocation();
  const classes = {}; //mainStyles.bodyStyles();
  const localStyles = useStyles();
  const gridContainer = {}; //mainStyles.gridMainContainer();
  const canvasRef = useRef(null);

  const [cancelAlert, setCancelAlert] = useState(false);
  const [cancelAction, setCancelAction] = useState(false);

  const [currentStage, setCurrentStage] = useState(0);
  const [totalStage, setTotalStage] = useState(0);

  //Redux hooks
  const auth = useSelector((state) => state.Authentication);
  const file = useSelector((state) => state.FileInfo);
  const wf = useSelector((state) => state.Workflow);
  // const autographSign = useSelector((state) => state.AutographSign);
  const cancelWF = useSelector((state) => state.CancelWorkFlow);
  const continueWFData = useSelector((state) => state.ContinueWorkflow);
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(addTitleLegoCurrent(t("legal_autograph_sign")));
    console.log("location.state", location.state);
    // CODIGO COMENTADO
    dispatch(fileActions.GetFileInfo(location.state.folioId));
    setCargaInicial(true);
    //Obtener direccion IP:
    obtenerDireccionIP((ip) => {
      setIpDirection(ip);
      console.log("Dirección IP:", ip);
    });
    setLoadView(true);
    console.log("PASOAQUI 1");
  }, []);

  useEffect(() => {
    console.log("PASOAQUI 2", file.items, cargaInicial);
    if (file.items != undefined && cargaInicial) {
      console.log("FILI INFO ---- ", file.items);
      getStageProperties(file.items);
      setCargaInicial(false);
      setLoadView(false);
      console.log("PASOAQUI 2");
    }
  }, [file, file.items]);

  useEffect(() => {
    if (cancelWF.items != undefined && cancelAction) {
      setLoadView(false);
      console.log("cancelWF.items*********************: ", cancelWF.items);
      if (cancelWF.items?.Stage != null) {
        let nextStage = cancelWF.items?.Stage;
        let stageName = nextStage.Name;
        let stageId = nextStage.Id;
        let folioId = file.items.Id;
        let stage = cancelWF.items?.Stage;

        let nextComponent = coreFunctions.GetLegoNext(stageName);
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: { stageName, stageId, stage, folioId },
        });
      }
    }
  }, [cancelWF]);

  // monica.coronel
  let getStageProperties = (element) => {
    // console.log("fileInfo: getStageProperties: ", fileInfo);
    // let stageName = element.Stage.Name;
    // let stageId = element.Stage.Id;
    const allDocuments =
      element.Stage?.DocumentalCategory.DocumentalGroups.flatMap(
        (group) =>
          group.DocumentTypes?.flatMap((item) =>
            item.Document != null ? [item.Document] : []
          ) || []
      );

    console.log(
      "setProperties",
      allDocuments,
      element.Stage.DocumentalCategory.DocumentalGroups[0].DocumentTypes
    );

    setProperties(
      element.Stage.DocumentalCategory.DocumentalGroups[0].DocumentTypes
    );
    // setProperties(element.Stage?.DocumentalCategory.DocumentalGroups[0].DocumentTypes?.filter(item => item.Document != null));
    setTotalStage(element.Stage.TotalStageGroups);
    setCurrentStage(element.Stage.CurrentStageGroup);
  };

  let clearCanvas = () => {
    canvasRef.current.clear();
    setFinFirma(null);
    setInicioFirma(null);
    setHidden(false);
    setSignBase64(false);
  };

  let setPlaceholder = () => {
    console.log("setPlaceholder................: ", isWriteSign);
    setIsWriteSign(true);
    console.log("setIsWriteSign(true) ................: ", isWriteSign);
    if (!inicioFirma) {
      setInicioFirma(new Date().toISOString());
    }
    setHidden(true);
    // setSignBase64(true);
  };

  let finaliza = () => {
    console.log("finaliza................: ", isWriteSign);
    setIsWriteSign(false);
    setFinFirma(new Date().toISOString());
    setSignBase64(true);
  };

  let handleGetCanvas = () => {
    if (canvasRef.current.isEmpty()) {
      alert(t("must_provide_signature"));
      console.log("aqui");
    } else {
      let cnv = canvasRef.current.getSignaturePad().toDataURL("image/png");
      AlertConfirm(
        {
          icon: "warning",
          noIcon: true,
          html: (
            <Box style={{ overflow: "hidden" }}>
              <Typography>{t("must_provide_signature_confirm")}</Typography>
              <Box
                style={{
                  border: `1px solid ${theme.palette.primary.main}!important`,
                  borderRadius: "8px",
                  margin: "12px",
                  padding: "12px",
                }}
              >
                <img
                  src={cnv}
                  alt="firma autográfa"
                  style={{ transform: "scale(1.5)" }}
                />
              </Box>
              <Typography
                textAlign={"center"}
                variant="body1"
                sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
              >
                {t("signed_continue_question")}
              </Typography>
            </Box>
          ),
          okbtntext: t("general_accept"),
          notbtntext: t("legal_reject"),
        },
        (result) => {
          console.log("resultresult", result);
          if (
            (result.isConfirmed == true || result?.value == true) &&
            result.isDismissed == false
          ) {
            console.log("resultresult", "ENTRO A AVANZAR");
            handleModalButton();
          } else if (
            result?.dismiss === "cancel" &&
            result.isDismissed == true
          ) {
            console.log("resultresult", "ENTRO A CANCELAR");
            // setOpenAlert(false)
          }
        }
      );
      // setOpenAlert(true)
    }
  };

  const handleModalButton = async () => {
    setSingContinue(null);
    let cnv = canvasRef.current.getSignaturePad().toDataURL("image/png");
    let points = canvasRef.current.toData();
    let signSplitted = cnv.split(",");
    let sign = signSplitted[1];
    let documentsArray = [];
    setLoadView(true);
    console.log("properties", properties);

    console.log("signSign", sign);

    let prpSession = sessionStorage.getItem("properties");

    const allDocumentTypes =
      file.items?.Stage?.DocumentalCategory.DocumentalGroups.flatMap((group) =>
        group.DocumentTypes.filter((item) => item.Document != null)
      );

    // return console.log("PROPIETIS", file.items.Stage, allDocumentTypes, JSON.parse(prpSession))

    // let documentData = (prpSession === null || prpSession?.length < 0 || prpSession?.length == 0) ?
    //   file.items.Stage?.DocumentalCategory.DocumentalGroups.find(item => (item.Name == "Formato autogenerado" || item.Name == "KIT Contratación")).DocumentTypes.filter(item => item.Document != null)
    //   : JSON.parse(prpSession)

    // properties.forEach((it) => {
    //   let documentId = documentData.find((i) => i.Id === it.Id).Document?.Id;
    //   documentsArray.push(documentId);
    // });

    // console.log("documentData", allDocumentTypes, documentsArray);
    // console.log("************documentsArray****************: ", documentsArray)
    setLoadView(true);
    let obj = {};
    let VideoEvidence = {};
    let AudioEvidence = {};
    let TrackingData = {};
    VideoEvidence.B64Content = "";
    VideoEvidence.Extension = "";
    VideoEvidence.DeferLoad = false;
    VideoEvidence.SkipActor = false;
    AudioEvidence.B64Content = "";
    AudioEvidence.Extension = "";
    AudioEvidence.DeferLoad = false;
    AudioEvidence.SkipActor = false;
    TrackingData.IMEI = "";
    TrackingData.Reference = "";
    let count = 0;

    console.log("PROPIETIS", allDocumentTypes);

    const promises = allDocumentTypes.map((it) => {
      count++;
      let actualDate = coreFunctions.getActualDateTime();
      let dateSplitted = actualDate.split("|");
      obj.ObjectId = it.Document.Id;
      obj.Signature = sign;
      obj.TimeStamp = `${dateSplitted[0]} ${dateSplitted[1]}`;
      obj.Latitude = latitude;
      obj.Longitude = longitude;
      obj.signetAtFSimple = new Date().toISOString();
      obj.MacAddress = ipDirection;
      obj.Width = 490;
      obj.Height = 550;
      obj.StartedAt = inicioFirma;
      obj.EndedAt = finFirma;
      obj.PuntosControl = points;
      obj.TrackingData = TrackingData;
      obj.ContinueWorkFlow = false;
      // obj.ContinueWorkFlow = count == allDocumentTypes.length;
      // console.log(" count < allDocumentTypes.length",count,allDocumentTypes.length,count == allDocumentTypes.length);
      // console.log("...objetoDeFirma...: ", obj);
      // return dispatch(documentsActions.AutographSign(obj));
      return documentsRequests.AutographSignDocument(obj);
    });

    try {
      const results = await Promise.all(promises);
      // console.log("resultsPromiss GRAL", results);
      const errores = results.filter((item) => item?.error);
      if (errores.length > 0) {
        Alert({
          icon: 0,
          title: errores[0]?.error,
        });
        setLoadView(false);
      } else {
        // console.log("resultsPromiss 2 ", results);
        setSingContinue(true);
        var fileId = file.items?.Id;

        let dataRequest = {
          File_Id: fileId,
        };
        console.log("ContinueWorkflowAction 2 ", dataRequest);
        dispatch(workflowActions.ContinueWorkflowAction(dataRequest));
      }
    } catch (error) {
      console.error("Error general en firma:", error);
      Alert({
        icon: 0,
        title: "Error al firmar los documentos.",
      });
      setLoadView(false);
    }
    //// console.log("Peticiones Firma", obj)

    // console.log("setOpenAlert")
    // setOpenAlert(false)
  };

  // useEffect(() => {
  //   if (!!autographSign.items) {
  //     console.log("autographSignTrue", autographSign, singContinue);
  //     if (autographSign.items.Stage != null && singContinue) {
  //       console.log("autographSignTrue BEUNA", autographSign, singContinue);
  //       setSingContinue(false);
  //       // console.log("idNextstage::::: ", autographSign.items.Id);
  //       console.log("NameNextstage::::: ", autographSign.items);

  //       let fileId = autographSign.items.WorkFlow?.File?.Id;
  //       console.log("NameNextstage::::: fileId ", fileId);

  //       let nextStage = autographSign.items.Stage;
  //       let stageName = nextStage.Name;
  //       let stageId = nextStage.Id;
  //       let folioId = file.items?.Id; // autographSign.items.WorkFlow?.File?.Id
  //       let stage = autographSign.items.Stage;

  //       let nextComponent = coreFunctions.GetLegoNext(stageName);
  //       dispatch(documentsActions.AutographSign(null, true));
  //       coreFunctions.DoNextStage({
  //         navigate,
  //         nextComponent,
  //         State: { stageName, stageId, stage, folioId },
  //       });
  //       setLoadView(false);
  //     }

  //     canvasRef.current.clear();
  //   } else if (autographSign.error != undefined && singContinue) {
  //     console.log("autographSignTrue ERROR", autographSign, singContinue);
  //     setLoadView(false);
  //     setSingContinue(false);
  //     alert(autographSign.error);
  //   }
  // }, [autographSign, autographSign.items]);

  // console.log("autographSign", autographSign);

  useEffect(() => {
    if (!!continueWFData.items) {
      // console.log("continueWFData", continueWFData, singContinue);
      if (continueWFData.items.Stage != null && singContinue) {
        // console.log("continueWFData BEUNA", continueWFData, singContinue);
        setSingContinue(false);
        // console.log("idNextstage::::: ", autographSign.items.Id);
        // console.log("NameNextstage::::: ", continueWFData.items);
      
        let nextStage = continueWFData.items.Stage;
        let stageName = nextStage.Name;
        let stageId = nextStage.Id;
        let folioId = file.items?.Id; // autographSign.items.WorkFlow?.File?.Id
        let stage = continueWFData.items.Stage;

        let nextComponent = coreFunctions.GetLegoNext(stageName);
        dispatch(documentsActions.AutographSign(null, true));
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: { stageName, stageId, stage, folioId },
        });
        setLoadView(false);
      }

      canvasRef.current.clear();
    } else if (continueWFData.error != undefined && singContinue) {
      console.log("continueWFData ERROR", continueWFData, singContinue);
      setLoadView(false);
      setSingContinue(false);
      alert(continueWFData.error);
    }
  }, [continueWFData, continueWFData.items]);

  const handleMouseEnter = () => {
    setEstaFirmando(true);
  };

  const handleTouchMove = (event) => {
    try {
      if (!estaFirmando) return;

      const rect = containerSignDetectRef.current.getBoundingClientRect();
      const touch = event.touches[0];

      if (
        touch.clientX < rect.left ||
        touch.clientX > rect.right ||
        touch.clientY < rect.top ||
        touch.clientY > rect.bottom
      ) {
        handleMouseLeave();
      }
    } catch (e) {}
  };

  const handleMouseLeave = () => {
    if (estaFirmando && isWriteSign) {
      // Realizar acciones necesarias cuando se sale del div al firmar
      Alert(
        {
          icon: "warning",
          okbtntext: t("signature_ok_button"),
          // okbtnclass: "confirmButtonSweetWarning",
          text: t("signature_warning_limit"),
        },
        (event) => {
          clearCanvas();
        }
      );
      clearCanvas();
    }
    setEstaFirmando(false);
  };

  return (
    <GenericContainer>
      <GeoLocationGeneric
        SuccessFN={(latitude, longitude) => {
          console.log("succes,latitude, longitude ", latitude, longitude);
          setLatitude(latitude);
          setLongitude(longitude);
        }}
        ErrorFN={(error) => console.log("error", error)}
      />
      {/* <Typography variant="h6">
      Firma autógrafa en mensaje de datos
    </Typography> */}
      <Typography variant="subtitle1">{t("legal_sign_message")}</Typography>
      {console.log("windowHeight.............: ", windowHeight)}
      <Box
        sx={{
          textAlign: "center",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height:
            windowHeight > 900
              ? "68vh"
              : matches
              ? "56vh"
              : windowHeight < 570
              ? "40vh"
              : "54vh",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            height: "43vh",
            alignContent: "center",
            marginTop: "24px",
            alignItems: "center",
            overflow: "hidden",
            textAlign: "center",
            justifyContent: "center",
            border: `1px solid ${theme.palette.primary.main}`,
            position: "relative",
            borderRadius: "8px",
            ["@media only screen and (max-width: 600px)"]: {
              height: windowHeight < 570 ? "33vh" : "47vh",
            },
          }}
          ref={containerSignDetectRef}
          onTouchStart={handleMouseEnter}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onTouchEnd={handleMouseLeave}
          onTouchMove={handleTouchMove}
        >
          <SignaturePad
            ref={canvasRef}
            backgroundColor="rgba(255,255,255, 0.0)"
            penColor="black"
            canvasProps={{ width: 1000, height: 490 }}
            onBegin={setPlaceholder}
            onEnd={finaliza}
          />
          {hidden ? null : (
            <Box
              sx={{
                position: "absolute",
                top: matches ? "45%" : "35%",
                left: "45%",
                ["@media only screen and (max-width: 812px)"]: {
                  top: "45%",
                  left: "38%",
                },
                paddingBottom: "0.5em",
              }}
            >
              <Typography
                variant="body1"
                gutterBottom
                className={localStyles.signPlaceholder}
              >
                {t("legal_sign_here")}
              </Typography>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignContent: "flex-end",
            alignItems: "flex-start",
            overflow: "hidden",
            marginTop: "16px",
            textAlign: "right",
            justifyContent: "flex-end",
          }}
        >
          {hidden ? (
            <DeleteOutlineIcon
              // fill={theme.palette.primary.main}
              className={localStyles.clearIconActive}
              onClick={clearCanvas}
            />
          ) : (
            <DeleteOutlineIcon
              // fill="#818285"
              className={localStyles.clearIcon}
              onClick={clearCanvas}
            />
          )}
        </Box>
      </Box>

      <Buttons
        ConfirmButtonText={t("general_accept")}
        onClickConfirm={handleGetCanvas}
        //CancelButtonText="Cancelar"
        /* onClickCancel={() => {
        AlertConfirm(
          {
            icon: "warning",
            html: <Box>
              <Typography
                textAlign={"center"}
                variant="body1"
                sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
              >
                {t("applicant_on_cancel")}
              </Typography>
            </Box>,
            okbtntext: "Aceptar",
            notbtntext: "Rechazar",
          },
          (result) => {
            if (result.isConfirmed) {
              setCancelAction(true)
              setLoadView(true)
              dispatch(workflowActions.CancelWorkFlow({ File_Id: file.items.Id }))
            } else if (result.dismiss === "cancel" && result.isDismissed) {
              // setCancelAlert(false)
            }
          }
        );
      }
        // setCancelAlert(true)
      } */
      />

      {loadView ? (
        <CustomLoadingOverlay
          active={loadView}
          text={t("general_loading_message")}
        />
      ) : null}

      {/* {openAlert &&
      <CustomAlertMaterial
        title='Firma autógrafa'
        body='Acabas de firmar y autorizar los documentos. ¿Deseas continuar?'
        closeAction={() => setOpenAlert(false)}
        open={openAlert}
        leftButtonText='Cancelar'
        leftButtonAction={() => setOpenAlert(false)}
        rightButtonText='Aceptar'
        rightButtonAction={handleModalButton}
      />
    } */}

      {/* {cancelAlert &&
      <CustomAlertMaterial
        title='Firma autógrafa'
        body='Al cancelar, deberás comenzar el proceso para una nueva solicitud. ¿Estas seguro de rechazar?'
        closeAction={() => setCancelAlert(false)}
        open={cancelAlert}
        leftButtonText='Cancelar'
        leftButtonAction={() => setCancelAlert(false)}
        rightButtonText='Aceptar'
        rightButtonAction={() => {
          setCancelAction(true)
          setLoadView(true)
          dispatch(workflowActions.CancelWorkFlow({ File_Id: file.items.Id }))
        }}
      />
    } */}
    </GenericContainer>
  );
}
